/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Back in Stock: handled by custom modal in assets/bis.js + snippets/bis-modal.liquid.
// (Replaced native klaviyo.enable("backinstock", ...) to support multi-locale — DE/NL/AT.)

// DC: Mehrere Collection-URLs für PDPs
(function() {
  var path = window.location.pathname;
  var match = path.match(/^\/collections\/[^\/]+\/products\/(.+)/);
  if (match) {
    var newUrl = "/products/" + match[1] + window.location.search + window.location.hash;
    window.location.replace(newUrl);
  }
})();



// PK: Variant-picker auto-switch to a valid combo
//
// Reads data-option-value directly from every radio (no ID-to-string guessing)
// and the full variants list from the <script data-all-variants> emitted by
// product-form.liquid. No fetch, no MutationObserver, no CSS injection: hiding
// of unreachable color swatches is handled server-side via the is-combo-disabled
// class. This handler only reacts to clicks that would land on a non-existent
// combination and silently flips the other radios to the closest valid variant
// before Focal's bubble-phase handler reads the DOM.
(function () {
  function getContext(input) {
    var picker = input.closest('variant-picker');
    if (!picker) return null;
    var formId = picker.getAttribute('form-id');
    if (!formId) return null;
    var tag = picker.querySelector('script[data-all-variants]');
    if (!tag) return null;
    var variants;
    try { variants = JSON.parse(tag.textContent); } catch (_) { return null; }
    if (!variants || !variants.length) return null;
    return { formId: formId, variants: variants, numOpts: variants[0].options.length };
  }

  function readSelections(ctx) {
    var sel = new Array(ctx.numOpts).fill(null);
    var inputs = document.querySelectorAll('input[data-option-position][form="' + ctx.formId + '"]');
    inputs.forEach(function (el) {
      if (el.type === 'radio' && !el.checked) return;
      var p = parseInt(el.dataset.optionPosition, 10) - 1;
      if (p >= 0 && p < ctx.numOpts) sel[p] = el.dataset.optionValue || null;
    });
    return sel;
  }

  function variantExists(variants, sel) {
    return variants.some(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    });
  }

  function findBestMatch(variants, changedPos, newValue, currentSel) {
    // Pick the variant that keeps the most of the user's other selections
    // and prefer available over unavailable if overlap ties.
    var best = null, bestScore = -1;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[changedPos] !== newValue) continue;
      var overlap = 0;
      for (var p = 0; p < v.options.length; p++) {
        if (p === changedPos) continue;
        if (v.options[p] === currentSel[p]) overlap++;
      }
      var score = overlap * 2 + (v.available ? 1 : 0);
      if (score > bestScore) { bestScore = score; best = v; }
    }
    return best;
  }

  function findInputByValue(formId, position, optionValue) {
    var inputs = document.querySelectorAll('input[data-option-position="' + position + '"][form="' + formId + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].dataset.optionValue === optionValue) return inputs[i];
    }
    return null;
  }

  function onChangeCapture(e) {
    var input = e.target;
    if (!input || !input.dataset || !input.dataset.optionPosition) return;
    if (input.type === 'radio' && !input.checked) return;

    var ctx = getContext(input);
    if (!ctx) return;

    var sel = readSelections(ctx);
    if (sel.some(function (x) { return x === null; })) return;
    if (variantExists(ctx.variants, sel)) return;

    var changedPos = parseInt(input.dataset.optionPosition, 10) - 1;
    var newValue = input.dataset.optionValue;
    if (newValue == null) return;

    var target = findBestMatch(ctx.variants, changedPos, newValue, sel);
    if (!target) return;

    // Silently flip other-position radios to the target variant's values. Setting
    // .checked on a radio does not fire change, and siblings in the same name=
    // group are auto-unchecked, so Focal's bubble-phase handler reads a single
    // consistent state and re-renders once.
    for (var p = 0; p < target.options.length; p++) {
      if (p === changedPos) continue;
      if (sel[p] === target.options[p]) continue;
      var nextInput = findInputByValue(ctx.formId, p + 1, target.options[p]);
      if (nextInput && !nextInput.checked) nextInput.checked = true;
    }
  }

  document.addEventListener('change', onChangeCapture, true);
})();

document.querySelectorAll('.jdgm-prev-badge__text').forEach(el => {
  const count = el.textContent.trim().split(' ')[0];
  el.textContent = '(' + count + ')';
});

/* Judge.me Vorschau-Badge ueber Focals Variantenwechsel hinweg korrekt halten.
   Focal ersetzt bei einem Variantenwechsel den ganzen <product-meta data-block-type="meta">
   Block (assets/theme.js, ProductRerender) und fuegt dabei Judge.mes serverseitig gecachtes
   Badge-Metafield neu ein: display:none, englisch ("3 reviews"), ohne Q&A. Judge.mes Observer
   macht das frische Node nur sichtbar, faehrt aber NICHT das volle Setup -> der Text faellt auf
   "reviews" zurueck und die "Fragen" (.jdgm-qa-badge) verschwinden.
   Der Badge ist produkt-, nicht variantenabhaengig: wir sichern den fertigen Render einmal
   (Marker: Klasse jdgm--done-setup) und stellen ihn nach jedem Swap wieder her. Reines Restore
   des identischen HTML + der Klassen -> kein Layout-/CSS-Eingriff; das wieder-gesetzte
   jdgm--done-setup laesst Judge.mes Observer das Node ueberspringen.
   Getriggert per MutationObserver, NICHT per variant:changed-Timer: variant:changed feuert
   VOR dem DOM-Swap (assets/theme.js, selectCombination), ein zeitbasiertes Restore muesste
   also blind auf den Swap warten. Der Observer reagiert timing-unabhaengig genau dann, wenn das
   degradierte Badge real im DOM landet. */
(function () {
  var SEL = '.product__info .jdgm-widget.jdgm-preview-badge';
  var goodHTML = null, goodClass = null, goodId = null;

  function badge() { return document.querySelector(SEL); }
  function isReady(w) { return !!w && w.classList.contains('jdgm--done-setup'); }

  function snapshot() {
    var w = badge();
    if (!isReady(w)) return false;
    goodHTML = w.innerHTML;
    goodClass = w.className;
    goodId = w.getAttribute('data-id');
    return true;
  }

  // Auf den vollstaendigen Judge.me-Render warten (max ~12s), dann sichern.
  function pollSnapshot() {
    var tries = 0;
    var iv = setInterval(function () {
      if (snapshot() || ++tries > 40) clearInterval(iv);
    }, 300);
  }

  function restore() {
    if (!goodHTML) return;
    var w = badge();
    if (!w || isReady(w)) return;                 // nicht vorhanden oder bereits korrekt -> kein Re-Trigger der eigenen Mutation
    if (w.getAttribute('data-id') !== goodId) {   // anderes Produkt (Combined Listing): Judge.me machen lassen + neu sichern
      goodHTML = null;
      pollSnapshot();
      return;
    }
    w.innerHTML = goodHTML;                        // deutscher Text + "Fragen" zurueck
    w.className = goodClass;                       // re-setzt jdgm--done-setup -> Observer ueberspringt das Node
  }

  pollSnapshot();

  // Stabiler Wurzelknoten: ueberlebt den partiellen Meta-Swap (Variantenwechsel) UND das
  // Ersetzen von <product-rerender> (Produktwechsel) -> Observer bleibt durchgehend aktiv.
  var rerender = document.querySelector('product-rerender');
  var root = (rerender && rerender.parentElement) || document.querySelector('.product__info') || document.body;
  if (root && window.MutationObserver) {
    // restore() ist idempotent (no-op sobald korrekt) -> die eigene Mutation erzeugt keine Schleife.
    new MutationObserver(restore).observe(root, { childList: true, subtree: true });
  }
})();

/* PDP fixed-corner buttons that must clear Focal's mobile sticky add-to-cart bar:
   - the back-to-top button (snippets/back-to-top.liquid, PDP only, bottom-right)
   - the accessibility button (snippets/accessibility-button.liquid, site-wide, bottom-left)
   We measure the bar height once and publish it as the CSS var --mokebo-sticky-dodge on
   <html>; both buttons read it via bottom: calc(<base> + var(--mokebo-sticky-dodge)). On
   desktop (>=1000px) the bar sits at the top, so the dodge is 0. The back-to-top button also
   toggles .is-visible after scrolling past ~0.6 viewport and smooth-scrolls to top on click. */
(function () {
  var btn = document.querySelector('[data-back-to-top]');
  var hasSticky = !!document.querySelector('product-sticky-form');
  if (!btn && !hasSticky) return;            // nothing on this page needs the logic

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Re-queried every call on purpose: Focal re-renders <product-sticky-form> on variant
  // change (it lives inside <product-rerender>), so a cached reference can go stale.
  function stickyOffset() {
    if (window.innerWidth > 999) return 0;            // desktop: the bar sits at the top
    var s = document.querySelector('product-sticky-form');
    if (!s || s.hasAttribute('hidden')) return 0;     // bar not currently shown
    return s.offsetHeight || 0;
  }

  function update() {
    if (btn) btn.classList.toggle('is-visible', window.pageYOffset > window.innerHeight * 0.6);
    root.style.setProperty('--mokebo-sticky-dodge', stickyOffset() + 'px');
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { update(); ticking = false; });
  }

  if (btn) {
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Focal shows/hides the sticky bar by toggling its [hidden] attribute via an
  // IntersectionObserver, which can fire without a scroll event. Watch the stable
  // <product-rerender> wrapper (subtree) so we catch that toggle AND survive the bar
  // being re-rendered on variant change, repositioning both buttons in lockstep.
  var stickyWrap = document.querySelector('product-rerender[id^="product-sticky-form-"]');
  if (stickyWrap && 'MutationObserver' in window) {
    new MutationObserver(update).observe(stickyWrap, { attributes: true, attributeFilter: ['hidden'], subtree: true });
  }

  update();
})();

/* PK: Nach einem Variantenwechsel auf Mobile zur Produktgalerie zurückscrollen.
   Auf Mobile liegt der Variant-Picker weit unter der Galerie: wer eine andere
   Farbe/Ausführung wählt, sieht das neue Produktbild nicht. Deshalb scrollt die
   Seite nach dem Wechsel sanft zurück an den Galerie-Anfang.
   Guards:
   - Early-Exit außerhalb der PDP (custom.js lädt deferred, DOM steht bereits),
   - nur < 1000px (Desktop hat die Galerie neben dem Formular),
   - nur nach echter User-Interaktion im variant-picker (pointerdown/keydown-
     Fenster; variant:changed allein könnte auch programmatisch feuern),
   - nur im Main-Product (Quick-Buy/Featured-Product nicht scrollen),
   - nur wenn sich das Varianten-Bild wirklich ändert (featured_media-Vergleich;
     Produkte ohne Variantenbilder springen sonst grundlos),
   - nur wenn die Galerie oben aus dem Viewport gescrollt ist.
   variant:changed feuert VOR dem DOM-Swap (assets/theme.js, selectCombination) —
   fürs Seiten-Scrollen egal, die Galerie-Position steht ja schon fest. */
(function () {
  if (!document.querySelector('.shopify-section--main-product variant-picker')) return;

  var lastPickerInteraction = 0;

  function markInteraction(e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-picker')) lastPickerInteraction = Date.now();
  }
  document.addEventListener('pointerdown', markInteraction, true);
  document.addEventListener('keydown', markInteraction, true);

  document.addEventListener('variant:changed', function (event) {
    if (!window.matchMedia('(max-width: 999px)').matches) return;
    // 5s-Fenster: selectCombination rendert die Sektion per Fetch nach, das darf
    // auf langsamem Mobilfunk dauern; Initial-Load/Programmatic bleibt draußen.
    if (Date.now() - lastPickerInteraction > 5000) return;

    var detail = event.detail || {};
    var variant = detail.variant;
    var prev = detail.previousVariant;
    if (!variant || !variant.id) return;
    if (prev && prev.id === variant.id) return;

    var newMedia = variant.featured_media && variant.featured_media.id;
    var oldMedia = prev && prev.featured_media && prev.featured_media.id;
    if (!newMedia || newMedia === oldMedia) return;

    var section = event.target && event.target.closest ? event.target.closest('.shopify-section--main-product') : null;
    if (!section) return;
    var media = section.querySelector('.product__media');
    if (!media) return;

    // Sticky-Header/Announcement-Bar-Höhe aus Focals CSS-Variablen, damit die
    // Galerie nicht unter dem Header landet.
    var cs = getComputedStyle(document.documentElement);
    var offset =
      (parseFloat(cs.getPropertyValue('--header-height')) || 0) * (parseFloat(cs.getPropertyValue('--enable-sticky-header')) || 0) +
      (parseFloat(cs.getPropertyValue('--announcement-bar-height')) || 0) * (parseFloat(cs.getPropertyValue('--enable-sticky-announcement-bar')) || 0);

    var rect = media.getBoundingClientRect();
    if (rect.top >= offset - 4) return; // Galerie-Anfang ist bereits im Viewport

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: window.pageYOffset + rect.top - offset, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
